import { Injectable, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { AdAccount } from '../interfaces/ad-account';
import { ApiService } from './api.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AdAccountService {
  // Dependency Injection
  private apiService: ApiService = inject(ApiService);  

  adAccounts: AdAccount[] = [];

  // Track if the service is currently loading ad accounts from the database to prevent firing multiple concurrent calls to the API
  loadingAdAccounts = false;

  // Create Subject (event listener) used to notify other components when the list of Ad Accounts is updated
  // Don't forget to implement unsubscribe() in ngOnDestroy() in components subscribing to this Subject
  adAccountsUpdated = new Subject<boolean>();

  // Create Subject (event listener) used to notify other components when the list of Ad Accounts is being loaded
  // Don't forget to implement unsubscribe() in ngOnDestroy() in components subscribing to this Subject
  adAccountsLoading = new Subject<boolean>();

  constructor() { 
    console.log("[AdAccountService] Initialising AdAccountService");
  }

  clearAdAccounts() {
    this.adAccounts = [];
  }

  countAdAccounts() {
    return this.adAccounts.length;
  }

  async getAdAccounts() {
    return new Promise<AdAccount[]>((resolve, reject) => {
      console.log("[AdAccountService] getAdAccounts()");   
      // Notify components listening to list of Ad Accounts being loaded from the server
      this.adAccountsLoading.next(true);
      this.loadingAdAccounts = true;
      let requestPath = '/ad-accounts/?list=all';
        let requestParams = { params:
          new HttpParams()
        }
        this.apiService.get(requestPath, requestParams)
        .then(response => {
          // console.log("[AdAccountService] Get response", response);   
          // Notify components listening to list of Ad Accounts being loaded from the server
          this.adAccountsLoading.next(false);
          this.loadingAdAccounts = false;
          let adAccounts: AdAccount[] = [];   
          _.forEach(response.data, (adAccount) => {
            let thisAdAccount: AdAccount = {
              id: adAccount.id,
              name: adAccount.name,
              logo: adAccount.logo
            };
            adAccounts.push(thisAdAccount);
          });
          console.log("[AdAccountService] getAdAccounts Ad Accounts retrieved", adAccounts);   
          this.adAccounts = adAccounts;
          // Notify components listening to list of Ad Accounts being updated (new Ad Account added or existing Ad Account deleted)
          this.adAccountsUpdated.next(true);
          resolve(adAccounts);
        })
        .catch(error => {
          console.log("[AdAccountService] getAdAccounts Get error", error.message);
          // Notify components listening to list of Ad Accounts being loaded from the server
          this.adAccountsLoading.next(false);
          this.loadingAdAccounts = false;
          reject(error.message);
        })
    });
  }

  async getAdAccount(id: string) {
    return new Promise<AdAccount>((resolve, reject) => {
      // console.log("[AdAccountService] getAdAccount()", id);   
      let requestPath = '/ad-accounts/?get=' + id;
        let requestParams = { params:
          new HttpParams()
        }
        this.apiService.get(requestPath, requestParams)
        .then(response => {
          // console.log("[AdAccountService] getAdAccount Get response", response);   
          let adAccount: AdAccount = {
            id: response.data.id,
            name: response.data.name,
            meta_id: response.data.meta_id,
            dashboard_id: response.data.dashboard_id
          };
          console.log("[AdAccountService] getAdAccount", adAccount);
          resolve(adAccount);
        })
        .catch(error => {
          console.log("[AdAccountService] getAdAccount Get error", error.message);
          // Notify components listening to list of Ad Accounts being loaded from the server
          this.adAccountsLoading.next(false);
          this.loadingAdAccounts = false;
          reject(error.message);
        })
    });
  }

}
